import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const title = 'Flexbox Wrap';
export const _frontmatter = {};
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "flexbox-wrap"
    }}>{`Flexbox Wrap`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Flex flexWrap='wrap' mx={-2}>
  <Box px={2} py={2} width={1/2}>
    <Text p={1} color='background' bg='primary'>1/2</Text>
  </Box>
  <Box px={2} py={2} width={1/2}>
    <Text p={1} color='background' bg='primary'>1/2</Text>
  </Box>
  <Box px={2} py={2} width={1/3}>
    <Text p={1} color='background' bg='primary'>1/3</Text>
  </Box>
  <Box px={2} py={2} width={1/3}>
    <Text p={1} color='background' bg='primary'>1/3</Text>
  </Box>
  <Box px={2} py={2} width={1/3}>
    <Text p={1} color='background' bg='primary'>1/3</Text>
  </Box>
  <Box px={2} py={2} width={1/4}>
    <Text p={1} color='background' bg='primary'>1/4</Text>
  </Box>
  <Box px={2} py={2} width={1/4}>
    <Text p={1} color='background' bg='primary'>1/4</Text>
  </Box>
  <Box px={2} py={2} width={1/4}>
    <Text p={1} color='background' bg='primary'>1/4</Text>
  </Box>
  <Box px={2} py={2} width={1/4}>
    <Text p={1} color='background' bg='primary'>1/4</Text>
  </Box>
</Flex>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      